export default function linkOrText($parse) {
  'ngInject';

  return {
    transclude: true,
    scope: true,
    template: `
      <a class="link-as-text" ui-sref="{{ sref }}" ng-transclude ng-if="if"></a>
      <span ng-transclude ng-else></span>
    `,
    link($scope, $element, $attrs) {
      const isLink = $parse($attrs.if).bind(null, $scope);
      Object.defineProperties($scope, {
        if: { get: () => isLink() },
        sref: { get: () => $attrs.sref },
      });
    },
  };
}
